import script from "./JournalStars.vue?vue&type=script&setup=true&lang=js"
export * from "./JournalStars.vue?vue&type=script&setup=true&lang=js"

import "./JournalStars.vue?vue&type=style&index=0&id=3457d327&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3457d327"]])

export default __exports__